import { Component } from '@angular/core';
import { HeaderComponent } from '../../modules/shared/components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../modules/shared/components/footer/footer.component';

@Component({
    selector: 'app-frame-page',
    templateUrl: './frame-page.component.html',
    styleUrl: './frame-page.component.scss',
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class FramePageComponent {

}
